import { Endpoint } from '../endpoint';
import { UserId } from '@business/entities/account';
import { BattlePlanSectionSortingResponse, BattlePlanSectionTaskResponse, SectionId, TaskId } from '@business/entities/battle_plan';
import { TaskStatusId } from '@business/entities/task_status';
import { CommonService } from '@business/services';

export function fetchBattlePlanTasks() {
  return Endpoint.get<BattlePlanSectionTaskResponse[]>(`@makh/battle-plan-section-tasks`);
}

export function fetchBattlePlanTask(id: TaskId) {
  return Endpoint.get<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks/task/${id}`);
}

export function deleteBattlePlanTasks(id: TaskId) {
  return Endpoint.delete<void>(`@makh/battle-plan-section-tasks/${id}`);
}

export function createBattlePlanTasks(data: Partial<BattlePlanSectionTaskResponse>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks`, { formData, hasFiles: true });
}

export function updateBattlePlanTasks(taskId: TaskId, data: Partial<BattlePlanSectionTaskResponse>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks/update/${taskId}`, { formData, hasFiles: true });
}

export function sortBattlePlanTasks(sectionId: SectionId, taskIds: TaskId[]) {
  return Endpoint.post<BattlePlanSectionTaskResponse[]>(`@makh/battle-plan-section-tasks/sort-battle-plan-section-tasks`, {
    data: { sectionId, taskIds },
  });
}

export function sortSectionTasks(section: BattlePlanSectionSortingResponse[]) {
  return Endpoint.post<BattlePlanSectionTaskResponse[]>(`@makh/battle-plan-section-tasks/sort-all-battle-plan-section-tasks`, {
    data: { section },
  });
}

export function markBattlePlanTasksCompleted(isCompleted: boolean, taskId: TaskId, userId: UserId) {
  return Endpoint.post<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks/mark-task-completed`, {
    data: { isCompleted, taskId, userId },
  });
}

export function updateStepStatus(targetId: TaskId, statusId: TaskStatusId | undefined) {
  return Endpoint.patch<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks/update-step-status/${targetId}`, { data: { statusId } });
}

export function updateAssignedusers(targetId: TaskId, userId: UserId[]) {
  return Endpoint.patch<BattlePlanSectionTaskResponse>(`@makh/battle-plan-section-tasks/update-assignee/${targetId}`, { data: { userId } });
}
